// PE-6229 — returning patient appointment cancellation email body

import { ReturningPatientAppointmentEmailFields } from './appointment-confirmation-email.builder';
import {
  applyMergeFields,
  buildOptionalParagraphBlock,
  buildTenantDepartmentBlock,
  escapeHtml,
} from './appointment-email-html.util';
import { RETURNING_PATIENT_APPOINTMENT_CANCELLATION_EMAIL_TEMPLATE } from './returning-patient-appointment-cancellation-email.template';

function buildAppointmentDetailMergeFields(
  fields: Omit<ReturningPatientAppointmentEmailFields, 'tenantName' | 'departmentName'>
): Record<string, string> {
  return {
    patientName: escapeHtml(fields.patientName),
    appointmentType: escapeHtml(fields.appointmentType),
    providerName: escapeHtml(fields.providerName),
    appointmentDate: escapeHtml(fields.appointmentDate),
    appointmentTime: escapeHtml(fields.appointmentTime),
    appointmentLocation: escapeHtml(fields.appointmentLocation),
    contactPhone: escapeHtml(fields.contactPhone),
    additionalNotesBlock: buildOptionalParagraphBlock(fields.additionalNotes),
  };
}

/** PE-6229 — same field pattern as confirmation email; cancellation wording. */
export function buildReturningPatientAppointmentCancellationEmailBody(
  fields: ReturningPatientAppointmentEmailFields
): string {
  const safe = {
    ...buildAppointmentDetailMergeFields(fields),
    preheaderText: escapeHtml(
      'Your appointment has been cancelled. View your cancelled appointment details.'
    ),
    tenantDepartmentBlock: buildTenantDepartmentBlock(fields.tenantName, fields.departmentName),
  };

  return applyMergeFields(RETURNING_PATIENT_APPOINTMENT_CANCELLATION_EMAIL_TEMPLATE, safe);
}
